<template>
  <div id="chatbot"></div>
</template>

<script>
import { defineComponent } from 'vue';

export default defineComponent({
  name: "ChatBot",

  mounted() {
    const injectScript = document.createElement("script");
    injectScript.src = "//code.tidio.co/ym9nkvtclt1jxgejy68cmiwv0ayqltaq.js";
    injectScript.async = true;
    document.head.appendChild(injectScript);

    injectScript.onerror = () => {
      console.error("Error loading ChatBot script");
    };
  },
});
</script>
